import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Payment from '../../../apis/payment';
import CommonUtils from '../../../utility/common-utilities';
import "./style.scss";

class SellerSetupRefresh extends React.Component {
   state = {
      staticText: {},
      sellerAccount: null,
      loading: true
   }

   componentDidMount() {
      const queryParams = CommonUtils.queryStringToJson(window.location.search)
      this.refreshOnboarding({ refreshId: queryParams?.id })
   }

   refreshOnboarding(payload = {}) {
      Payment.refreshPaymentAccountOnboarding(payload).then((response) => {
         window.location.assign(response.onboardLink)
      }).catch((err) => {
         this.setState({ loading: false })
      })
   }


   render() {
      return (
         <div className="payment-seller-container" style={{
            height: window.innerHeight, width: window.innerWidth
         }}>
            <div className="p-4 d-flex align-self-center">
               <div className="cp-flex-1 text-center">
                  <FontAwesomeIcon spin size="1x" icon={faCircleNotch} />
               </div>
               <div className="cp-flex-2">
                  <span className="pl-4 semi-bold-text">
                     Redirecting to Stripe to continue onboarding process. Please don't refresh the page.
                  </span>
               </div>
            </div>
         </div>
      )
   }
}

export default SellerSetupRefresh;